import {
  Button,
  Center,
  Flex,
  Spinner,
  Tab,
  Table,
  TableContainer,
  TabList,
  Tabs,
  Tbody,
  Thead,
  Tr
} from '@chakra-ui/react'
import SearchBar from 'components/SearchBar'
import useSortedPools, { PoolSortMethod } from 'hooks/pool/useSortedPools'
import { useCallback, useState } from 'react'
import React from 'react'
import { Pool } from 'types/pool'

import { poolsListHeaders, PoolVersion } from './constants'
import CreateNewPoolMenu from './CreateNewPoolMenu'
import PoolTableHeader from './PoolTableHeader'
import PoolTableRow from './PoolTableRow'
import { isSearchBarEnabled } from 'appConstants'

export interface PoolsTableProps {
  isFetchingPage: boolean
  isLoadingPools: boolean
  onPoolVersionChange: (poolVersion: PoolVersion) => void
  onQueryChange: (query: string) => void
  pools: Pool[]
  poolVersions: PoolVersion[]
  query: string
  selectedPoolVersion: PoolVersion
  hasNextPage?: boolean
  onLoadMoreClick?: () => void
  rewardPriceUSD?: number
}

const PoolsTable = ({
  hasNextPage,
  isFetchingPage,
  isLoadingPools,
  onLoadMoreClick,
  onPoolVersionChange,
  onQueryChange,
  pools,
  poolVersions,
  query,
  rewardPriceUSD,
  selectedPoolVersion
}: PoolsTableProps) => {
  const [sortMethod, setSortMethod] = useState<PoolSortMethod>(
    PoolSortMethod.LIQUIDITY
  )
  const [isSortDescending, setIsSortDescending] = useState<boolean>(true)
  const sortedPools = useSortedPools({
    isSortDescending,
    pools,
    sortMethod
  })

  console.log("sortedPools", sortedPools, pools)

  const onHeaderClick = useCallback(
    (method?: PoolSortMethod) => {
      if (!method) return
      sortMethod !== method
        ? setSortMethod(method)
        : setIsSortDescending((previous) => !previous)
    },
    [sortMethod]
  )

  return (
    <Flex flexDir="column" gap={4} pt={4}>
      <Flex flexDir={{ base: 'column', sm: 'row' }} justify={isSearchBarEnabled?"space-around":"space-between"} mx={4} gap={2}>
        <Tabs
          variant="soft-rounded-white"
          flexShrink={0}
          index={poolVersions.indexOf(selectedPoolVersion)}
          onChange={(index) => onPoolVersionChange(poolVersions[index])}
        >
          <TabList>
            {poolVersions.map((poolVersion, i) => (
              <Tab key={i}>{poolVersion}</Tab>
            ))}
          </TabList>
        </Tabs>
     {isSearchBarEnabled &&   <SearchBar
          placeholder="Search by name, symbol or address"
          value={query}
          onValueChange={onQueryChange}
          size="lg"
        />}
        <CreateNewPoolMenu />
      </Flex>
      {isLoadingPools ? (
        <Center mt={8}>
          <Spinner />
        </Center>
      ) : (
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                {poolsListHeaders.map((header, i) => (
                  <PoolTableHeader
                    key={i}
                    selectedSortMethod={sortMethod}
                    isSortDescending={isSortDescending}
                    {...header}
                    onClick={() => onHeaderClick(header.sortMethod)}
                  />
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {sortedPools.map((pool) => (
                <PoolTableRow
                  key={pool.pairAddress}
                  pool={pool}
                  rewardPriceUSD={rewardPriceUSD}
                />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
      {!isLoadingPools &&
        query === '' &&
        sortedPools.length > 0 &&
        hasNextPage ? (
        <Button
          variant="primary"
          colorScheme="accent"
          alignSelf="center"
          w="160px"
          isLoading={isFetchingPage}
          loadingText="Loading"
          onClick={onLoadMoreClick}
        >
          Load More
        </Button>
      ) : null}
    </Flex>
  )
}

export default PoolsTable
